export function getAddressFieldName(index: number): string {
  return index === 0 ? 'sourcePoint.address' : (`destinationPoints.${index - 1}.address` as const)
}
